import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { IMultipleIdsParams } from '../../../spacesPlatform/utils/actionParams';

export interface IPerformExtractEncryptionActionOnDatasourcesParams extends IMultipleIdsParams {
  type: string;
}

export class PerformExtractEncryptionActionOnDatasourcesRequest extends Request<IPerformExtractEncryptionActionOnDatasourcesParams, IResult> {
  constructor(ids: string[], type: string) {
    super('performExtractEncryptionActionOnDatasources', {
      ids: ids,
      type: type
    });
  }
}
